import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ReceivableDetail from '@app/views/Ledger/ReceivableDetail';
import { memo } from 'react';

export default memo(
  withIfUser(ReceivableDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
